import React from 'react';

const LineBreak = () => {
  return <br/>;
};

export default LineBreak;